module.exports = __webpack_public_path__ + "img/Maagtechnic_Grafik_3D_de-DE.bd961de5.png";